import {button,escapeHtml,message} from '../ui/components.js';

function replacementOptions(model,smokerId,selected=null){
  const items=(model?.smokers?.items||[]).filter(item=>item.id!==smokerId);
  return items.map(item=>
    '<option value="'+escapeHtml(item.id)+'"'+(selected===item.id?' selected':'')+'>'+escapeHtml(item.name)+'</option>'
  ).join('');
}

export function smokerArchiveMarkup({plan,model,selectedReplacementId=null}={}){
  if(!plan?.smokerId)throw new TypeError('Smoker archive plan is required');
  const smoker=(model?.smokers?.items||[]).find(item=>item.id===plan.smokerId);
  const smokerName=smoker?.name||'Wędzarnia';

  const history=plan.hasHistoricalSessions
    ?message({
      text:'Ta wędzarnia ma powiązaną historię. Zostanie ukryta z aktywnego sprzętu, ale dane historyczne pozostaną zachowane.',
      kind:'warning'
    })
    :'<p class="panel-copy">Wędzarnia zostanie usunięta z aktywnego sprzętu. Rekord pozostanie zarchiwizowany, aby późniejsze dane historyczne nie straciły odniesienia.</p>';

  const replacement=plan.requiresReplacementSelection
    ?'<label class="field" for="replacement-smoker"><span class="field-label">Nowa domyślna wędzarnia</span><select id="replacement-smoker" name="replacementDefaultId" required><option value="">Wybierz…</option>'+replacementOptions(model,plan.smokerId,selectedReplacementId)+'</select></label>'
    :plan.wasEffectiveDefault&&plan.replacementDefaultId
      ?'<p class="panel-copy">Po usunięciu domyślną wędzarnią zostanie automatycznie inny dostępny sprzęt.</p>'
      :'';

  const last=plan.leavesNoActiveSmoker
    ?message({text:'To ostatnia aktywna wędzarnia. Po usunięciu dashboard pokaże pusty stan i pozwoli dodać nową.',kind:'warning'})
    :'';

  return '<form id="archive-smoker-form" class="smoker-form" data-smoker-id="'+escapeHtml(plan.smokerId)+'">'+
    '<div class="smoker-form-section"><span class="eyebrow">Moja wędzarnia</span><h2>Usuń „'+escapeHtml(smokerName)+'”?</h2>'+
    history+last+replacement+
    '</div><div class="actions">'+
      button({id:'confirm-archive-smoker',label:'Usuń wędzarnię',variant:'danger',type:'submit'})+
      button({id:'cancel-archive-smoker',label:'Anuluj',variant:'ghost'})+
    '</div></form>';
}
